export default "__VITE_ASSET__H5x4ihDh__"